import { Routes, Route } from "react-router-dom";
import PIsList from "./PIsList";

export default function PIsPage() {
    return (
        <Routes>
            <Route path="/" element={<PIsList />}/>
        </Routes>
    )
}